import * as React from 'react'
import { OrderElement } from '../order_types'


type FileShape = {
  id: string
  name: string
  _new?: boolean
  _destroy?: boolean
  src?: string
}

type FileInputsProps = {
  file: FileShape
  inputAttributeName: (name: string, row: string) => string
  index: number
  row: string
}

function FileInputs({ file, inputAttributeName, row, index }: FileInputsProps) {
  // eslint-disable-next-line no-underscore-dangle
  if (file._new) {
    return (
      <>
        <input
          type="hidden"
          name={`${inputAttributeName('order_photos_attributes', row)}[${index}][temp_file]`}
          value={file.src}
        />
        {file.name && (
          <input
            type="hidden"
            name={`${inputAttributeName('order_photos_attributes', row)}[${index}][original_file_name]`}
            value={file.name}
          />
        )}
      </>
    )
  }
  // eslint-disable-next-line no-underscore-dangle
  if (file._destroy) {
    return (
      <>
        <input
          type="hidden"
          name={`${inputAttributeName('order_photos_attributes', row)}[${index}][id]`}
          value={file.id}
        />
        <input
          type="hidden"
          name={`${inputAttributeName('order_photos_attributes', row)}[${index}][_destroy]`}
          value="1"
        />
      </>
    )
  }
  return null
}


type FilesAttributesProps = {
  element: OrderElement
  inputAttributeName: (name: string, row: string) => string
  row: string
}

export default function FilesAttributes(props: FilesAttributesProps) {
  const { element, inputAttributeName, row } = props
  const files: Array<FileShape> = element.uploader_options?.files || []

  return (
    <>
      {files.map((file, index) => (
        <FileInputs file={file} row={row} inputAttributeName={inputAttributeName} index={index} key={file.id} />
      ))}
    </>
  )
}
